export { default } from './ServiceAttributes';
